<template>
<svg viewBox="0 0 40 32" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-double-triangle-left`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M40 2.003v27.994c0 1.718-2.024 2.636-3.317 1.504l-16-13.996a1.99 1.99 0 01-.683-1.48v13.972c0 1.718-2.024 2.636-3.317 1.504l-16-13.996a2 2 0 010-3.01L16.683.5C17.976-.633 20 .286 20 2.003v13.972a1.99 1.99 0 01.683-1.48L36.683.5C37.976-.633 40 .286 40 2.003zM16 6.41L5.037 16 16 25.59V6.41zm20 0L25.037 16 36 25.59V6.41z"/></svg>
</template>
<script>

export default {
  name: 'IconDoubleTriangleLeft',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
